var pinList = {
    pin : [],
    selectedPin : '',
}
export default pinList;